import { api } from 'api';
import { IdType } from 'ts/IdType';
import { getFileRequest, GetFileRequestParams, GetFileRequestResponse } from 'features/app/api/getFileRequest';

export const getOrderReportCsvRequest = async (params: GetFileRequestParams): GetFileRequestResponse =>
  getFileRequest('/orders/own-history/', params);

export const resendEmailRequest = async (id: IdType) => api.post(`/orders/resend/${id}/`);
